import { Card, Chip, Modal, ModalContent, useDisclosure } from '@nextui-org/react'
import SelectTank from '../../pages/SelectTank'
import useHomeStockStore from '../../store/home/useHomeStockStore'
import { SubmitTankArrayType } from '../../types/apiResponse/tankTypes'

export const SelectStockTanks = () => {
  const { selectedTanks, setSelectedTanks, selectTanksBorderColor } = useHomeStockStore()
  const {
    isOpen: isOpenTanks,
    onOpen: onOpenTanks,
    onOpenChange: onOpenChangeTanks,
  } = useDisclosure()

  return (
    <>
      <div className="mt-3 font-bold" data-testid="tanks-to-stock-label">
        Tanks to Stock
      </div>
      <Card
        className={`flex flex-row flex-wrap justify-start p-1 ${selectTanksBorderColor} border-opacity-60 min-h-[3rem]`}
        radius="sm"
        shadow="sm"
        isPressable
        onPress={onOpenTanks}
        data-testid="tanks-to-stock-field"
        role="button"
        aria-label="Tanks to Stock selection field"
        tabIndex={0}
      >
        <Modal
          isOpen={isOpenTanks}
          onOpenChange={onOpenChangeTanks}
          isDismissable={false}
          isKeyboardDismissDisabled={true}
          size="3xl"
          data-testid="tanks-selection-modal"
        >
          <ModalContent data-testid="tanks-selection-modal-content">
            {(onCloseTanks) => (
              <SelectTank
                submitTankArray={(tankSelectedList: SubmitTankArrayType) =>
                  setSelectedTanks(tankSelectedList)
                }
                batchIds={['$empty']}
                onClose={onCloseTanks}
                initialTankArray={selectedTanks}
              />
            )}
          </ModalContent>
        </Modal>
        {selectedTanks.map((item, index) => (
          <Chip
            key={index}
            radius="sm"
            classNames={{
              base: 'border-small border-tdpldarkgrey bg-tdpllightgrey border-opacity-60 m-1 p-0',
              content: 'font-bold',
            }}
            data-testid={`selected-tank-chip-${item.tankName}`}
          >
            {item.tankName}
          </Chip>
        ))}
        {selectedTanks.length === 0 && (
          <div
            className="flex items-center justify-center text-gray-500 text-sm min-h-[2rem] w-full"
            data-testid="tanks-to-stock-placeholder"
          >
            Click to select tanks for stocking
          </div>
        )}
      </Card>
      {selectTanksBorderColor && selectTanksBorderColor.includes('tdplmaroon') ? (
        <p className="m-0 text-sm font-semibold text-tdplmaroon" data-testid="tanks-to-stock-error">
          You need to select at least one empty tank.
        </p>
      ) : (
        <p data-testid="tanks-to-stock-error-placeholder"> </p>
      )}
    </>
  )
}
